(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-home-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeVeloraHeroCarousels = () => {
    document.querySelectorAll('[data-velora-hero-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-velora-hero-slide]'));
      if (slides.length < 2) return;

      carousel.dataset.carouselReady = 'true';
      let activeIndex = 0;
      let rotationTimer;

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== activeIndex;
          slide.querySelectorAll('[data-velora-hero-dot]').forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === activeIndex);
          });
        });
      };

      const startRotation = () => {
        window.clearInterval(rotationTimer);
        rotationTimer = window.setInterval(() => showSlide(activeIndex + 1), 5000);
      };

      carousel.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-velora-hero-dot]');
        const previous = event.target.closest('[data-velora-hero-previous]');
        const next = event.target.closest('[data-velora-hero-next]');

        if (dot) {
          showSlide(Number(dot.dataset.veloraHeroDot));
          startRotation();
        } else if (previous) {
          showSlide(activeIndex - 1);
          startRotation();
        } else if (next) {
          showSlide(activeIndex + 1);
          startRotation();
        }
      });

      carousel.addEventListener('mouseenter', () => window.clearInterval(rotationTimer));
      carousel.addEventListener('mouseleave', startRotation);
      startRotation();
    });
  };

  document.addEventListener('DOMContentLoaded', initializeVeloraHeroCarousels);
  document.addEventListener('shopify:section:load', initializeVeloraHeroCarousels);

  } catch(e) { console.error(e); }
})();
})();
